﻿<template>
  <v-dialog v-if="withTextField"
            ref="dialog"
            v-model="modal"
            :return-value.sync="date"
            persistent
            width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field :name="name"
                    :id="id"
                    :value="dateFormatted"
                    :label="label"
                    :disabled="disabled"
                    :prepend-icon="icon"
                    readonly
                    :clearable="clearable"
                    :hint="hint"
                    :persistent-hint="hasHint"
                    :loading="loading"
                    @click:clear="clear"
                    v-on="on"
                    :error-messages="validations"></v-text-field>
    </template>

    <v-date-picker v-model="date" 
                   scrollable locale="es-ES" 
                   first-day-of-week="1" 
                   :allowed-dates="allowedDates"
                   :type="calendarType"
                   v-if="isModeCalendar">
      <v-spacer></v-spacer>
      <v-btn text v-on:click="modal = false">Cancelar</v-btn>
      <v-btn text color="primary" v-on:click="$refs.dialog.save(date)">Aceptar</v-btn>
    </v-date-picker>

    <v-time-picker v-model="date" :format="formatHour" scrollable locale="es-ES" v-else>
      <v-spacer></v-spacer>
      <v-btn text v-on:click="modal = false">Cancelar</v-btn>
      <v-btn text color="primary" v-on:click="$refs.dialog.save(date)">Aceptar</v-btn>
    </v-time-picker>
  </v-dialog>

  <div v-else>
    <v-date-picker v-model="date" scrollable locale="es-ES" first-day-of-week="1" :allowed-dates="allowedDates" :disabled="disabled" v-if="isModeCalendar"></v-date-picker>
    <v-time-picker v-model="date" :format="formatHour" scrollable locale="es-ES" :disabled="disabled" v-else></v-time-picker>
  </div>
</template>


<script>
import moment from 'moment';
export default {
  name: 'v-mydatepicker',
  props: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    mode: {
      type: String,
      default: '0'
    },
    value: {
      type: String
    },
    dataInitValue: {
      type: String,
      required: false
    },
    validationErrors: {
      type: Array,
      required: true,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    allowedDates: {
      type: Function,
      required: false
    },
    withTextField: {
      type: Boolean,
      required: false,
      default: true
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    },
    formatHour: {
      type: String
    },
    hint: {
      type: String
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: vm => ({
    modal: false,
    date: null,
    validations: vm.validationErrors,
  }),
  computed: {
    isModeDate() {
      return this.mode === '0'
    },
    isModeTime() {
      return this.mode === '1'
    },
    isModeMonth() {
      return this.mode === '2';
    },
    isModeCalendar() {
      return this.isModeDate || this.isModeMonth;
    },
    calendarType() {
      return this.isModeMonth ? 'month' : 'date';
    },
    icon() {
      return this.isModeCalendar ? 'mdi-calendar' : 'mdi-calendar-clock';
    },
    formatStr() {
      return this.isModeDate ? 'DD-MM-YYYY' : 'MM-YYYY';
    },
    formatStrReversed () {
      return this.formatStr.split('').reverse().join('');
    },
    dateFormatted() {
      if (this.isModeTime) return this.date;
      
      return this.date ? moment(this.date).format(this.formatStr) : '';
    },
    hasHint () {
      return !!this.hint;
    }
  },
  watch: {
    value(val) {
      if (this.isModeTime) return;
      if (val === this.dateFormatted) return;
      
      this.date = val ? moment(val, this.formatStr).format(this.formatStrReversed) : null;
    },
    validationErrors(val) {
      this.validations = val;
    },
    dateFormatted(val) {
      this.$emit('input', val);
      this.resetErrors();
    }
  },
  methods: {
    clear() {
      this.date = null;
    },
    resetErrors() {
      this.validations = [];
    },
    setInitValue() {
      if (!this.dataInitValue) return;
      
      if (this.isModeTime) {
        this.date = this.dataInitValue;
        return;
      }
      
      this.date = moment(this.dataInitValue).format(this.formatStrReversed)
    }
  },
  created() {
    this.setInitValue();
  }
};
</script>